import { iUsers, iHome, iThumbsUp } from '@hover/icons';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { IProsRestorationInfo } from '../interfaces/IProsRestorationInfo';
import { IProsRestorationCustomer } from '../interfaces/IProsRestorationCustomer';

export const PROS_RESTORATION_INFO: Array<IProsRestorationInfo> = [
  {
    id: 0,
    icon: iUsers,
    header: 'ENGAGE SMARTER WITH CARRIERS',
    body: 'HOVER’s comprehensive and accurate measurements - from a few smartphone photos - help you communicate project scope more effectively with adjusters throughout the claims process.',
  },
  {
    id: 1,
    icon: iHome,
    header: 'HANDLE MORE CLAIMS',
    body: 'Enable your team to gather and submit information quickly and accurately using HOVER’s measurements report and .esx file. Do more with less to maintain profits margins when a storm hits - even when labor is limited.',
  },
  {
    id: 2,
    icon: iThumbsUp,
    header: 'BUILD CREDIBILITY',
    body: 'Don’t just tell, show. Inspire trust and stand out from the competition by helping homeowners understand their claim packet and select products and colors via an interactive 3D model of their home.',
  },
];

export const PROS_RESTORATION_CUSTOMERS: Array<IProsRestorationCustomer> = [
  {
    id: 0,
    body: "\"Our corporate culture is to 'be the best we can be' and 'reach our highest potential' - this technology and partnership helps us do that.\"",
    image: (
      <StaticImage
        src="../assets/images/pros_restoration_legacy_restoration.png"
        alt="legacy restoration"
        placeholder="blurred"
        objectFit="contain"
        height={68}
      />
    ),
  },
  {
    id: 1,
    body: '"Any technology we use is focused on improving the customer’s experience. With HOVER, we can insure transparency, speed and efficiency from the first touchpoint with the adjuster until the homeowner is truly satisfied with the end result."',
    image: (
      <StaticImage
        src="../assets/images/pros_restoration_endeavor_exteriors.png"
        alt="endeavor exteriors"
        placeholder="blurred"
        objectFit="contain"
        height={48}
      />
    ),
  },
  {
    id: 2,
    body: '"With all the storms this year, there’s no way we could have handled the job volume without HOVER. The platform allowed us to save time on traveling, measuring, meetings and ordering materials. The app is a dream come true."',
    image: (
      <StaticImage
        src="../assets/images/pros_restoration_gcs.png"
        alt="gcs"
        placeholder="blurred"
        objectFit="contain"
        height={68}
      />
    ),
  },
];
